<template>
  <el-dialog
  title="指定发货日期"
  :visible.sync="visibleDialog"
  width="440px"
  top="calc(50vh - 130px)"
  class="pop-dialog pop-set-date"
  append-to-body>
  <div class="date-con">
    <div class="tips">如设定后，销售订单状态在发货中（待备货）被物流审核后则不能修改。</div>
    <div class="lable">发货日期</div>
    <el-date-picker
      v-model="time"
      class="data-picker"
      type="date"
      placeholder="选择日期"
      formart="yyyy-MM-dd"
      value-format="yyyy-MM-dd"
      size="mini"
      :picker-options="pickerOptions">
    </el-date-picker>
  </div>
  <template slot="footer">
    <el-button @click="visibleDialog = false" size="mini">取 消</el-button>
    <el-button type="primary" @click="onConfirm" size="mini">确 定</el-button>
  </template>
</el-dialog>
</template>
<script>
  export default {
    name:'popSetDate',
    data () {
      return {
        visibleDialog:false,
        time:'',
        pickerOptions: {
          disabledDate(time) {
            const today = new Date();
            today.setHours(0, 0, 0, 0);
            return time.getTime() < today.getTime();
          }
        }
      }
    },

    methods: {
       // 批量设置不需要回显
      show(item) {
        if (typeof item === 'object') {
          this.time = item.time
        }else {
          this.time = ''
        }
        console.log('show:',item)
        this.visibleDialog = true
      },
      // 确认修改
      onConfirm() {
        if (this.time) {
          let appointTime = this.time.substring(0, 10)
          if (appointTime) {
            let data = {
              appointTime
            }
            this.$emit('hasSetDate',data)
          }
          this.visibleDialog = false
        }else{
          this.$message.warning('请选择发货日期')
        }
        
      },
    },
  }
</script>
<style lang='scss'>
.pop-set-date{
  .date-con{
    padding: 10px 0 0 0;
    height: 148px;
    .tips{
      height: 36px;
      background-color: rgba($color: #EDB840 , $alpha: .2);
      border-radius: 2px;
      font-size: 12px;
      line-height: 36px;
      color: #EDB840;
      text-indent: 10px;
    }
    .lable{
      height: 46px;
      box-sizing: border-box;
      padding-top: 22px;
      font-size: 13px;
    }
    .data-picker{
      width: 198px;
    }
  }
}
</style>